import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getBlog } from "services";
import { Blog } from "types/blogs";

export const useBlog = () => {
  const [blog, setBlog] = useState<Blog>();
  const { id } = useParams();

  useEffect(() => {
    id &&
      Promise.all([getBlog({ id: Number(id) })]).then(([{ data: blog }]) => {
        setBlog(blog);
      });
  }, [id]);

  return { blog };
};
